import Tooltip from 'bootstrap/js/dist/tooltip';

document.addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '[data-bs-toggle="tooltip"]' ).forEach( function ( el ) {
		new Tooltip( el );
	} );
} );
